import styled from 'styled-components';
import Card from '../../shared/Card';

export const Project = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.6fr;
  grid-gap: 10px;
  border-top-left-radius: inherit;
  border-bottom-left-radius: inherit;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-template-rows: 0.8fr 1fr;
    border-top-right-radius: inherit;
    border-top-left-radius: inherit;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: ${(p) => p.theme.accent.primary}30;
  padding: 1.5rem 0.4rem;
  border-radius: inherit;

  @media screen and (max-width: 768px) {
    padding: 0.8rem 0.2rem;
  }
`;

export const Image = styled.img`
  display: block;
  height: 250px;
  border-radius: 5px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.12),
    0 4px 4px rgba(0, 0, 0, 0.12), 0 8px 8px rgba(0, 0, 0, 0.12),
    0 16px 16px rgba(0, 0, 0, 0.12);

  @media screen and (max-width: 768px) {
    height: 150px;
  }

  @media screen and (max-width: 900px) and (min-width: 768px) {
    height: 200px;
  }
`;

export const InfoWrapper = styled.div`
  padding: 1.2rem 1rem;

  @media screen and (max-width: 768px) {
    padding: 0.6rem;
  }
`;

export const Title = styled.h2`
  display: block;
  color: ${(p) => p.theme.accent.secondary};
  font-size: 1.5rem;
  margin-top: -0.5rem;

  @media screen and (max-width: 768px) {
    font-size: 1.2rem;
    margin-top: -0.2rem;
  }
`;

export const Stack = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

export const Item = styled.div`
  margin-right: 15px;
  margin-bottom: 10px;
  padding: 0.2rem 0.5rem;
  text-align: center;
  border: 2px solid ${(p) => p.theme.accent.primary};
  color: ${(p) => p.theme.accent.dark};
  background: ${(p) => p.theme.accent.primary}10;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;

  @media screen and (max-width: 768px) {
    font-size: 0.9rem;
    margin-right: 8px;
  }

  &:hover {
    background: ${(p) => p.theme.accent.primary}20;
    transition: 0.2s all ease-in-out;
  }
`;

export const Links = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90px;
  margin-top: 1.5rem;

  @media screen and (max-width: 768px) {
    width: 70px;
    margin-top: 0.5rem;
    margin-left: auto;
  }
`;

export const Details = styled.div`
  @media screen and (min-width: 900px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 90%;
  }
`;

export const Container = styled.div`
  margin: 0.5rem 0;

  @media screen and (min-width: 900px) {
    margin: 1.5rem 0;

    ${Card}:nth-of-type(even) ${Project} {
      grid-template-columns: 0.6fr 1fr;
      border-top-right-radius: inherit;
      border-bottom-right-radius: inherit;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    ${Card}:nth-of-type(even) ${Project} ${InfoWrapper}:last-child {
      order: -1;
    }

    ${Card}:nth-of-type(odd) ${Title}, ${Card}:nth-of-type(odd) p {
      text-align: right;
    }

    ${Card}:nth-of-type(odd) ${Stack} {
      justify-content: flex-end;
    }

    ${Card}:nth-of-type(odd) ${Stack} ${Item} {
      margin-right: 0;
      margin-left: 15px;
    }

    ${Card}:nth-of-type(odd) ${Links} {
      margin-left: auto;
    }
  }
`;
